// Implements layer.js...


export default {
  namespaced: true,
  state: {
    className:'layer_imagery',
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    define_from_config_sub(context,config){
      if (config.layer_type=='Tile' && config.source_type=='XYZ') {
        return context.dispatch('define_XYZ',config)
      }else if (config.layer_type=='Tile' && config.source_type=='BingMaps') {
        // TEMPORARY: ol.source.BingMaps is deprecated and Bing Maps for Enterprise (Basic) keys
        // stopped working June 30, 2025. Hitting the unauthenticated virtualearth.net tile
        // endpoint directly (quadkey-based) as a stopgap until migrated to Azure Maps.
        const tilePrefix=imagerySetToTilePrefix(config.imagerySet)
        context.state.map_layer=new ol.layer.Tile({
          source: new ol.source.XYZ({
            tileUrlFunction: function (tileCoord) {
              if (!tileCoord) return undefined
              const z=tileCoord[0]
              const x=tileCoord[1]
              //y is negative and minus 1, same quirk as layer_imagery_couchdb.js tileUrlFunction
              const y=Math.abs(tileCoord[2]+1)
              const quadKey=tileXYToQuadKey(x,y,z)
              return 'https://ecn.t3.tiles.virtualearth.net/tiles/'+tilePrefix+quadKey+'.jpeg?g=0&dir=dir_n'
            },
            attributions: [new ol.Attribution({
              html: [config.attributions_html || '© Microsoft, Maxar']
            })]
          }),
          visible:config.visible
        })
      }else {
        console.error('Not a layer imagery type defined ' + config.layer_type + '-' +config.source_type)
        return Promise.reject( 'Not a layer imagery type defined')
      }
      return Promise.resolve(config.layer_id)
    },
    define_XYZ(context,config){
      return context.dispatch('getUrl',config).then(url=>{
        if(url){
          return context.dispatch('defineByUrl',url)
        }else{
          return context.dispatch('defineByUrlNull',config)
        }
      }).then(rep=>{
        return Promise.resolve(config.layer_id)
      })
    },
    getUrl(context,config){
      return Promise.resolve(config.url) //simple, but useful for other layer that Implements this one
    },
    defineByUrl(context,url){
      let config=context.state.config
      // get the attachment
      context.state.map_layer=new ol.layer.Tile({
        source: new ol.source.XYZ({
          url: url,
          attributions: [new ol.Attribution({
            html: [config.attributions_html]
          })]
        }),
        visible:config.visible
      })
    },
    defineByUrlNull(){
      //others should implement that... should not happen
      return Promise.reject( 'Url not defined')
    }
  },

}

//quadkey conversion for the virtualearth.net direct tile endpoint - see BingMaps branch above
function tileXYToQuadKey(x,y,z){
  let quadKey=''
  for(let i=z;i>0;i--){
    let digit=0
    const mask=1<<(i-1)
    if((x&mask)!==0) digit+=1
    if((y&mask)!==0) digit+=2
    quadKey+=digit
  }
  return quadKey
}

function imagerySetToTilePrefix(imagerySet){
  switch(imagerySet){
    case 'Road':
    case 'RoadOnDemand':
      return 'r'
    case 'AerialWithLabels':
    case 'AerialWithLabelsOnDemand':
      return 'h'
    case 'Aerial':
    default:
      return 'a'
  }
}
